<div
    class="title-action flex flex-wrap justify-between items-center gap-y-1"
    [class.top-0]="isSticky"
    [class.sticky]="isSticky"
    [class.panel-tools-dialog]="isPanelToolsDialog"
>
    <div class="panel-buttons flex justify-start items-center">
        <ng-container *ngFor="let button of buttons?.global; trackBy: trackByIcon">
            <!-- Если условия отображения есть -->
            <ng-container *ngIf="button.displayConditions; else elseEmptyDisplayConditions">
                <ng-container *ngIf="itemData[button.displayConditions.field] === button.displayConditions.value">
                    <fui-button
                        (clickEvent)="callParent(button.click, itemData)"
                        [label]="button.label"
                        [title]="button.title"
                        [type]="button.type ? button.type : 'button-icon'"
                        [icon]="button.icon"
                        [height]="buttonsHeight"
                        [color]="button.color ? button.color : 'flat'"
                        [borderRadius]="button.borderRadius ? button.borderRadius : 'circle'"
                        [iconSize]="button.iconSize ? button.iconSize : 14"
                        [disabled]="button.isDisabled"
                    >
                    </fui-button>
                </ng-container>
            </ng-container>
            <ng-template #elseEmptyDisplayConditions>
                <!-- Если условий отображения нет -->
                <fui-button
                    (clickEvent)="callParent(button.click, itemData)"
                    [label]="button.label"
                    [title]="button.title"
                    [type]="button.type ? button.type : 'button-icon'"
                    [icon]="button.icon"
                    [height]="buttonsHeight"
                    [color]="button.color ? button.color : 'flat'"
                    [borderRadius]="button.borderRadius ? button.borderRadius : 'circle'"
                    [iconSize]="button.iconSize ? button.iconSize : 14"
                    [disabled]="button.isDisabled"
                >
                </fui-button>
            </ng-template>
        </ng-container>
        <div *ngIf="buttons?.globalMenu.length > 0">
            <fui-button
                [matMenuTriggerFor]="breadcrumbsMenu"
                [title]="dictionary.system_actions"
                type="button-icon"
                icon="dots-vertical"
                height="{{ buttonsHeight }}"
                color="{{ buttonMenuConfig?.color ? buttonMenuConfig?.color : 'soft-outline' }}"
                borderRadius="{{ buttonMenuConfig?.borderRadius ? buttonMenuConfig?.borderRadius : 'rounded' }}"
                iconSize="14"
                class="panel-buttons__kebab-button"
            >
            </fui-button>
            <mat-menu #breadcrumbsMenu="matMenu">
                <ng-container *ngFor="let button of buttons?.globalMenu; trackBy: trackByAction">
                    <!-- Если условия отображения есть -->
                    <button
                        *ngIf="
                            button.displayConditions &&
                            itemData[button.displayConditions.field] === button.displayConditions.value
                        "
                        class="context-menu-item"
                        mat-menu-item
                        [class.divider-custom-buttons]="button?.dividerCustomButtons"
                        [class.divider]="button?.divider"
                        (click)="callParent(button.click, itemData)"
                        [disabled]="button.disabled"
                        [ngStyle]="{ color: button?.textColor }"
                    >
                        <div class="flex flex-row items-center">
                            <ng-container *ngIf="button.icon">
                                <mat-icon aria-hidden="true" fontSet="mdi" [fontIcon]="'mdi-' + button.icon">
                                </mat-icon>
                            </ng-container>
                            <span [ngStyle]="{ color: button.textColor }">{{ button.label }}</span>
                        </div>
                        <span *ngIf="button.keyboardKey" class="keyboard-key"> &nbsp;({{ button.keyboardKey }}) </span>
                    </button>
                    <!-- Если условий отображения нет -->
                    <button
                        *ngIf="!button.displayConditions"
                        class="context-menu-item"
                        mat-menu-item
                        [class.context-red]="button.click === 'deleteItem'"
                        [class.divider-custom-buttons]="button?.dividerCustomButtons"
                        [class.divider]="button?.divider"
                        (click)="callParent(button.click, itemData)"
                        [disabled]="button.isDisabled"
                        [ngStyle]="{ color: button?.textColor }"
                    >
                        <div class="flex flex-row items-center">
                            <ng-container *ngIf="button.icon">
                                <mat-icon aria-hidden="true" fontSet="mdi" [fontIcon]="'mdi-' + button.icon">
                                </mat-icon>
                            </ng-container>
                            <span [ngStyle]="{ color: button.textColor }">{{ button.label }}</span>
                        </div>
                        <span *ngIf="button.keyboardKey" class="keyboard-key"> &nbsp;({{ button.keyboardKey }}) </span>
                    </button>
                </ng-container>
            </mat-menu>
        </div>
    </div>
    <div class="extras-wrapper">
        <ng-content select="[slot=extraRightBlock]"> </ng-content>
        <ng-container *ngIf="showLangButton && langService.languageCount > 1">
            <mat-divider class="title-divider"></mat-divider>
            <div class="row items-center justify-center panel-tools-lang" *ngIf="showLangButton">
                <fui-button
                    label="{{ dictionary.system_input_language }}: {{
                        langService.currentLanguage$ | async | uppercase
                    }}"
                    title="{{ dictionary.system_header_change_language }}"
                    icon="chevron-down"
                    height="{{ buttonsHeight }}"
                    color="flat"
                    positionIcon="right"
                    iconSize="14"
                    [matMenuTriggerFor]="menuFormLanguage"
                >
                </fui-button>
                <mat-menu #menuFormLanguage="matMenu">
                    <div *ngFor="let lang of langService?.languages | keyvalue">
                        <ng-container *ngIf="(langService.currentLanguage$ | async) !== lang?.value.lang">
                            <button mat-menu-item class="context-menu-item" (click)="changeLangForm(lang?.value)">
                                <span>{{ lang?.value?.names[langService.defaultLanguage] }}</span>
                            </button>
                        </ng-container>
                    </div>
                </mat-menu>
            </div>
        </ng-container>
        <ng-container *ngIf="showRequiredLabel">
            <mat-divider class="title-divider"></mat-divider>
            <div class="text-required flex items-center justify-center cursor-default">
                <span>* - {{ dictionary.required_fields }}</span>
            </div>
        </ng-container>
        <mat-divider *ngIf="helpLink?.length > 0" class="title-divider title-divider-last"></mat-divider>
        <div class="end-buttons">
            <ng-container *ngIf="helpLink">
                <div class="flex justify-center items-center">
                    <fui-button
                        class="panel-button"
                        (clickEvent)="appService.openHelpPage(helpLink)"
                        title="{{ dictionary.system_help }}"
                        type="button-icon"
                        icon="help-circle"
                        height="{{ buttonsHeight }}"
                        color="{{ helpButtonConfig?.color ? helpButtonConfig?.color : 'flat' }}"
                        borderRadius="{{ helpButtonConfig?.borderRadius ? helpButtonConfig?.borderRadius : 'circle' }}"
                        iconSize="14"
                    >
                    </fui-button>
                </div>
            </ng-container>
            <mat-divider class="title-divider" *ngIf="showCloseButton"></mat-divider>
            <ng-container *ngIf="showCloseButton">
                <fui-button
                    class="panel-button"
                    (clickEvent)="callParent('closePage', {})"
                    title="{{ dictionary.system_close }}"
                    type="button-icon"
                    icon="close"
                    height="{{ buttonsHeight }}"
                    color="flat"
                    borderRadius="circle"
                    iconSize="14"
                >
                </fui-button>
            </ng-container>
        </div>
    </div>
</div>
